const palette = {
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  primary: {
    light: '#009AFF',
    main: '#0075FF',
    dark: '#2242CD',
    50: '#EBF7FF',
    100: '#BAE0FF',
    200: '#8BCEFF',
    300: '#53BAFF',
    400: '#14AAFF',
    500: '#009AFF',
    600: '#008BFF',
    700: '#0075FF',
    800: '#1564EC',
    900: '#2242CD',
  },
  secondary: {
    light: '#9E9E9E',
    main: '#616161',
    dark: '#212121',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  error: {
    light: '#ff5533', // selected using MUI's color tool
    main: '#ea0000',
    dark: '#af0000', // selected using MUI's color tool
  },
  warning: {
    light: '#ffe24b', // selected using MUI's color tool
    main: '#f4b000',
    dark: '#bc8100', // selected using MUI's color tool
  },
  info: {
    light: '#ae57ff', // selected using MUI's color tool
    main: '#741fff',
    dark: '#2e00ca', // selected using MUI's color tool
  },
  success: {
    light: '#64ff4f', // selected using MUI's color tool
    main: '#00d308',
    dark: '#00a000', // selected using MUI's color tool
  },
}

export default palette

